import './NightN.scss';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import FetchingSpinner from 'components/fetching-spinner';
import NoData from 'components/no-data';
import PdfViewer from 'components/pdf-viewer';
import useGetFile from 'middleware/hcp/files/useGetFile';
import useGetNightlyReport from 'middleware/hcp/reports/useGetNightlyReport';

const NoMeta = () => {
  const { t } = useTranslation();
  const { recording } = useParams();

  const { reportsList, reportsLoading, reportsError } = useGetNightlyReport(
    recording ? [recording] : []
  );
  const { file, fileLoading, fileError } = useGetFile(
    reportsList?.length === 1 ? reportsList[0].file : ''
  );

  if (
    (reportsError && !reportsLoading) ||
    (fileError && !fileLoading) ||
    (!reportsLoading && reportsList?.length === 0)
  ) {
    return <NoData type="info" message={t('no-data')} description={t('nightly.no-report')} />;
  }
  if (fileLoading || reportsLoading || reportsList?.length !== 1 || !file) {
    return <FetchingSpinner />;
  }

  return (
    <div className="nightncontent" data-testid="nightn-nometa-container">
      <Row className="main-row" gutter={[16, 16]}>
        <Col xs={{ span: 24 }}>
          <a className="download-report" href={file} target="_blank" rel="noreferrer">
            <Button
              id="download-report"
              size="middle"
              disabled={fileLoading}
              icon={<DownloadOutlined />}
              data-testid="nightn-download-report-btn"
              type="primary">
              {t('download-report')}
            </Button>
          </a>
          {file && recording ? <PdfViewer file={file} id={recording} /> : <FetchingSpinner />}
        </Col>
      </Row>
    </div>
  );
};

export default NoMeta;
